// extracted by mini-css-extract-plugin
module.exports = {"root":"CompleteLink_root__gFYb8","rootSuccess":"CompleteLink_rootSuccess__1LWlK","rootFailure":"CompleteLink_rootFailure__2betp","isDisabled":"CompleteLink_isDisabled__2z8OW"};